export default {
    assistant: {
        welcome: 'Willkommen in der sharesuite!',
        yourName: 'Hey! Wie heißen Sie?',
        name: 'Name',
        namePlaceholder: 'Vor- und Nachname',
        workFor: 'Für wen arbeiten Sie?',
        company: 'Unternehmen',
        companyPlaceholder: 'Muster GmbH',
        moreToCompany: 'Mehr zu Ihrem Unternehmen',
        industry: 'Industrie',
        industries: {
            retail: 'Einzelhandel',
            finance: 'Finanzdienstleister',
            administration: 'Öffentliche Verwaltung',
            healthcare: 'Gesundheitswesen',
            law: 'Recht',
            media: 'Medien',
            technology: 'Technologie',
            property: 'Immobilien',
            other: 'Sonstiges'
        },
        companySize: 'Unternehmensgröße',
        want: 'Mit der sharesuite möchte ich...',
        projectManagement: '... Projekte verwalten',
        taskManagement: '... Aufgaben erstellen',
        dmsManagement: '... Dokumente abspeichern',
        activitiesManagement: '... Tätigkeiten erfassen',
        crmManagement: '... Kundenkontakte festhalten',
        firstProject: 'Benennen Sie Ihr erstes Projekt',
        project: 'Projekt',
        projectPlch: 'z.B. Qualitätssicherung',
        task: 'Was gibt es zu tun?',
        taskName: 'Aufgabe',
        taskPlch1: 'z.B. Überprüfung der Produktion',
        taskPlch2: 'z.B. Freigabe der Produktion',
        done: 'Geschafft!',
        finished: 'Es kann losgehen',
        next: 'Weiter',
        back: 'Zurück',
        toStart: 'Wir haben Ihnen eine E-Mail mit allen nötigen Informationen geschickt, um am PC loszulegen! ' +
            'Wenn Sie mit Ihrem Smartphone loslegen möchtest, laden Sie sich die App in einem der Appstores herunter.',
        startPC: 'Am PC starten',
        required: 'Erforderlich'
    },
    common: {
        male: 'Herr',
        female: 'Frau',
        pleaseChoose: 'Bitte wählen',
        username: 'Benutzername / E-Mail',
        email: 'E-Mail',
        firstname: 'Vorname',
        lastname: 'Name',
        password: 'Passwort',
        tos: 'AGB',
        dataPrivacy: 'Datenschutzerklärung',
        login: 'Anmelden',
        rememberMe : 'Angemeldet bleiben',
        createPassword: 'Passwort erstellen',
        confirmPassword: 'Passwort wiederholen',
        register: 'Registrieren',
        loginLink: 'Ich habe bereits einen sharesuite Account',
        agb: 'Ich akzeptiere die {tos} und {dataPrivacy}*',
        newsLetter: "Haltet mich über Neuigkeiten, Tipps und Tricks per E-Mail auf dem Laufenden.",

        errors: {
            commonError: 'Ein Fehler ist aufgetreten.',
            fieldRequired: 'Feld ist erforderlich',
            fieldEmailRequired: 'Bitte geben Sie eine korrekt formatierte E-Mail ein',
            fieldMinLength: 'Feld muss mindestens {amount} Zeichen haben',
            passwordConfirmError: 'Passwörter müssen gleich sein',

            userExists: 'Benutzer existiert bereits.',
        }
    },
    invitation: {
        helloTextWithContext: 'Sie wurden zur Zusammenarbeit mit sharesuite in den Arbeitsbereich {context} eingeladen. Zum Start brauchen wir nur noch ein paar Informationen und schon kann es los gehen!',
        helloText: 'Sie wurden zur Zusammenarbeit mit sharesuite eingeladen. Zum Start brauchen wir nur noch ein paar Informationen und schon kann es los gehen!',

        errors: {
            invitationExpired: 'Einladung ist abgelaufen.'
        }
    },
    register: {
        helloText: "Willkommen bei sharesuite",
        start: "Loslegen",
        workspaceName: "Wie soll Ihre sharesuite heißen?",
        demoData: 'Mit Demodaten starten',
        demoDataHint: "Für einen einfacheren Start besteht hier die Möglichkeit direkt fiktive Demodaten für <br>Projekte, Aufgaben etc. für deine sharesuite zu erstellen.",
        workspaceHelp: "In der Regel ist dies der Name des eigenen Unternehmens oder Projektes für was <br>sharesuite verwendet werden soll. Wir bezeichnen dies als Workspace wobei der Name <br>jederzeit später noch angepasst werden kann.",
        registerText : "Zum Start brauchen wir nur noch ein paar Informationen und schon kann es los gehen!",

        activeSession : {
            title : "Aktive Sitzung",
            text : "Sie sind bereits in einem anderen Tab oder Fenster bei sharesuite angemeldet. Bitte speichern Sie Ihre offenen Änderungen.",
            confirm: "OK"
        },

        errors: {
            tokenNotFound: "Ihre E-Mail-Adresse konnte nicht verifiziert werden."
        }
    },
    registerMailSent: {
        header: 'Sie erhalten in Kürze eine Bestätigungsmail.',
        text: 'Noch keine Mail erhalten? Prüfe bitte Sie Ihren Spam-Ordner!',
        footer: "Vielen Dank für Ihre Registrierung."
    },
    registerSuccess: {
        go: 'Loslegen',
        header: 'Herzlichen Glückwünsch! Die Registrierung wurde erfolgreich abgeschlossen!',
        text: 'Viel Spaß bei der Zusammenarbeit mit sharesuite. Unser Support-Team steht bei Fragen gerne unter support@sharesuite.com zur Verfügung. Besuchen Sie gerne unsere Homepage, um sharesuite auch für Ihr Unternehmen zu entdecken! Unsere App ist sowohl für Apple als auch für Android-Geräte verfügbar und steht in dem jeweiligen Store zum Download bereit!'
    },
    registerUserExists: {
        header: 'Benutzer bereits vorhanden.',
        text: 'Ihre Email-Adresse ist bereits bei uns registriert.',
        footer: '',
        login: "Anmelden",
        forgotPassword: "Passwort vergessen?"
    },
    join: {
        helloTextWithContext: 'Sie wurden zur Zusammenarbeit mit sharesuite in den Arbeitsbereich {context} eingeladen. Melden Sie sich an um fortzufahren.',
        helloText: 'Sie wurden zur Zusammenarbeit mit sharesuite eingeladen. Melden Sie sich an um fortzufahren.',
        registerLink: 'Jetzt neuen Account registrieren',
        forgotPasswordLink: 'Passwort vergessen?',
        joinContextSuccess: 'Sie sind erfolgreich dem Workspace beigetreten... Sie werden weitergeleitet zur sharesuite',

        errors: {
            invitationUsed: 'Einladung wurde bereits eingelöst. Sind Sie schon bei {context}?',
            alreadyInContext: 'Sie sind bereits in {context}.',
            invitationInvalidName: 'Der eingegebene Benutzername stimmt nicht mit dem auf der Einladung angegebenen Benutzernamen überein',
            invitationInvalid: 'Ihre Einladung ist leider ungültig. Bitte kontaktiere die Person, die Sie eingeladen hat.',
            loginFailed: 'Login ist fehlgeschlagen, überprüfen Sie die Zugangsdaten.',
            noContextAvailable: 'Login ist fehlgeschlagen, für Ihren Benutzer ist kein Arbeitsbereich hinterlegt.'
        }
    },
    login: {
        failedUserLocked: "Login ist fehlgeschlagen, der Zugang wurde nach zu vielen Anmeldeversuchen gesperrt. Bitte setzen Sie Ihr Passwort zurück."
    },
    requestPasswordReset: {
        helloText: 'Geben Sie Ihre Email-Adresse ein, um Ihr Passwort zurückzusetzen.',
        joinLink: 'Jetzt anmelden',
        registerLink: 'Jetzt neuen Account registrieren',
        go: 'Passwort zurücksetzen',

        errors: {
            userNotFound: 'Benutzer konnte nicht gefunden werden.'
        }
    },
    requestPasswordResetSuccess: {
        header: 'Eine E-Mail mit einer Anleitung zum Zurücksetzen Ihres Passwortes wurde an {email} verschickt.',
        text: 'Bitte überprüfen Sie Ihr E-Mail Postfach für weitere Informationen um Ihr Passwort zurückzusetzen und in der sharesuite anzumelden.'
    },
    resetPassword: {
        text: 'Bitte geben Sie ein neues und sicheres Passwort für Ihren sharesuite Account ein.',

        errors: {
            tokenExpired: 'Ihre Passwort zurücksetzen Anfrage ist abgelaufen. Bitte senden Sie eine neue Anfrage.'
        }
    },
    resetPasswordSuccess: {
        header: 'Ihr Passwort wurde erfolgreich zurückgesetzt!',
        text: 'Sie können sich jetzt mit Ihrem neuen Passwort in der sharesuite anmelden.',
        go: 'Anmelden'
    },

    trialLanding: {
        text: "Danke für Ihre Registrierung. In wenigen Sekunden werden Sie zu Ihrer sharesuite weitergeleitet..."
    }
};
